import axios from 'axios';
import { isEmpty } from 'ramda';

import { applications, parserUtils } from 'z-js-commons';

import { API_URL, S3_IMAGES_URL } from '../config';
import * as types from '../constants/ActionTypes';
import { fixExerciseStructure } from '../lib/exerciseTransformations/fixExerciseStructure';
import { getAbsolutePathforImageAndAudio } from '../lib/exerciseTransformations/utilsForImageAndAudioPath';
import { convertContentPathsToTaxonomy, getContextId } from '../lib/TaxonomyUtils';
import { translateItemTypesName } from '../lib/ExerciseUtils';
import { handleUnauthorizedError } from '../lib/heartBeat';

export const EDIT_EXERCISE_FROM_ARCHIVE = 'EDIT_EXERCISE_FROM_ARCHIVE';
export const EDIT_EXERCISE_FROM_DRAFT = 'EDIT_EXERCISE_FROM_DRAFT';
export const EDIT_EXERCISE_FROM_EDITORIAL = 'EDIT_EXERCISE_FROM_EDITORIAL';
export const EDIT_EXERCISE_FROM_SEARCH = 'EDIT_EXERCISE_FROM_SEARCH';

export const UPLOAD_IMAGE_START = 'UPLOAD_IMAGE_START';
export const UPLOAD_IMAGE_SUCCESS = 'UPLOAD_IMAGE_SUCCESS';
export const UPLOAD_IMAGE_FAILURE = 'UPLOAD_IMAGE_FAILURE';

const goToExercise = (history, id, qs, path) =>
    id ? history.push(`${path}/exercise/${id}?${qs ? qs : ''}`) : history.push(`${path}/exercise?${qs ? qs : ''}`);

const formatParameterForQuery = i => (i && !isEmpty(i) ? `[${i.toString()}]` : '');

export function editExerciseFromArchive(history, id, qs) {
    return async dispatch => {
        dispatch({
            type: EDIT_EXERCISE_FROM_ARCHIVE,
            exerciseId: id
        });
        goToExercise(history, id, qs, '/myLibrary');
    };
}

export function editExerciseFromDraft(history, qs) {
    return async dispatch => {
        dispatch({
            type: EDIT_EXERCISE_FROM_DRAFT
        });
        goToExercise(history, undefined, qs, '');
    };
}

export function editExerciseFromEditorial(history, id, qs) {
    return async dispatch => {
        dispatch({
            type: EDIT_EXERCISE_FROM_EDITORIAL,
            exerciseId: id
        });

        goToExercise(history, id, qs, '/search');
    };
}

export function editExerciseFromSearch(history, id, qs) {
    return async dispatch => {
        dispatch({
            type: EDIT_EXERCISE_FROM_SEARCH,
            exerciseId: id
        });
        goToExercise(history, id, qs, '/search');
    };
}

// UNUSED? REMOVEME
export function getExerciseById(id) {
    const url = `${API_URL}/cv/items`;
    return async dispatch => {
        dispatch({
            type: types.FETCH_EXERCISE,
            exerciseId: id
        });
        try {
            const { data } = await axios.get(`${url}?itemIds=[${id}]&etag=${Math.random() * 1000}`);
            dispatch({
                type: types.FETCH_EXERCISE_SUCCESS,
                result: data && data.length > 0 ? fixExerciseStructure(data[0]) : null
            });
        } catch (e) {
            handleUnauthorizedError(e, dispatch);
            dispatch({
                type: types.FETCH_EXERCISE_FAILURE,
                error: e
            });
        }
    };
}

export const getExerciseByIdAndGetTaxonomiesBySubject = id => async dispatch => {
    dispatch({
        type: types.FETCH_EXERCISE,
        exerciseId: id
    });
    try {
        const url = `${API_URL}/cv/items`;
        const { data } = await axios.get(`${url}?itemIds=[${id}]&etag=${Math.random() * 1000}`);
        dispatch({
            type: types.FETCH_EXERCISE_SUCCESS,
            result: data && data.length > 0 ? fixExerciseStructure(data[0]) : null
        });
        if (data && data.length > 0 && data[0].subjects && Array.isArray(data[0].subjects) && data[0].subjects.length > 0) {
            dispatch({ type: types.GET_CONTENT_TAXONOMY });
            try {
                const url = `${API_URL}/taxonomies/contents/cv?origin=${applications.CREA_VERIFICHE}`;
                const subjectsIds = data[0].subjects.map(subject => subject.id);
                const { data: taxonomies } = await axios.get(`${url}&subjects=${formatParameterForQuery(subjectsIds)}&etag=${Math.random() * 1000}`, {
                    withCredentials: true
                });
                dispatch({
                    type: types.GET_CONTENT_TAXONOMY_SUCCESS,
                    result: taxonomies
                });
            } catch (e) {
                handleUnauthorizedError(e, dispatch);
                dispatch({
                    type: types.GET_CONTENT_TAXONOMY_FAILURE,
                    error: e
                });
            }
        }
    } catch (e) {
        dispatch({
            type: types.FETCH_EXERCISE_FAILURE,
            error: e
        });
    }
};

export function getUserExercises(filters, userExercisePage = 0) {
    if (filters == null) {
        filters = {
            favouriteOnly: false
        };
    }
    userExercisePage++;
    const url = `${API_URL}/cv/items/teacher`;
    return async dispatch => {
        dispatch({
            type: userExercisePage === 1 ? types.GET_USER_EXERCISES : types.GET_MORE_USER_EXERCISES,
            filters: filters,
            page: userExercisePage
        });
        try {
            const {
                data: { data, totalCount }
            } = await axios.get(`${url}?page=${userExercisePage}&favourites=${filters.favouriteOnly}&etag=${Math.random() * 1000}`);
            dispatch({
                type: userExercisePage === 1 ? types.GET_USER_EXERCISES_SUCCESS : types.GET_MORE_USER_EXERCISES_SUCCESS,
                result: data.map(e => ({ ...fixExerciseStructure(e), UGC: true })),
                totalCount,
                userExercisePage
            });
        } catch (e) {
            handleUnauthorizedError(e, dispatch);
            dispatch({
                type: userExercisePage === 1 ? types.GET_USER_EXERCISES_FAILURE : types.GET_MORE_USER_EXERCISES_FAILURE,
                error: e
            });
        }
    };
}

export function openExercisePreview(exercise) {
    return {
        type: types.OPEN_EXERCISE_PREVIEW,
        exercise
    };
}

export function resetExercises() {
    return {
        type: types.RESET_EXERCISES
    };
}

export function resetSearch() {
    return {
        type: types.RESET_SEARCH
    };
}

export function saveExercise(exercise, exerciseInfo, originName, callback) {
    const url = `${API_URL}/cat/item`;
    return async dispatch => {
        dispatch({ type: types.SAVE_EXERCISE });
        const bodyPost = {
            ...exercise,
            UGC: true,
            applicationId: applications.CREA_VERIFICHE
        };
        try {
            const { data } = await axios.post(url, bodyPost);
            const exerciseSaved = {
                UGC: true,
                id: data.id,
                ...(data.sharedtextNodeId && { sharedtextNodeId: data.sharedtextNodeId }),
                ...(data.sharedTextXml && { sharedTextXml: data.sharedTextXml }),
                ...(data.audioNodeId && { audioNodeId: data.audioNodeId }),
                ...(data.audioXml && { audioXml: data.audioXml }),
                subject: exerciseInfo ? exerciseInfo.subject : { id: data.subjectId },
                taxonomy: convertContentPathsToTaxonomy(data.contentPaths),
                title: data.publicTitle,
                type: {
                    id: data.type,
                    label: translateItemTypesName(data.typeLabel)
                },
                difficulty: data.difficulty,
                xml: getAbsolutePathforImageAndAudio(data.xml)
            };
            dispatch({
                type: types.SAVE_EXERCISE_SUCCESS,
                exercise: exerciseSaved,
                originalExercise: {
                    id: exerciseInfo.id,
                    originName: originName
                }
            });
            if (callback) {
                callback(exerciseSaved);
            }
        } catch (e) {
            handleUnauthorizedError(e, dispatch);
            dispatch({
                type: types.SAVE_EXERCISE_FAILURE,
                error: e
            });
        }
    };
}

export function searchExerciseByIds(idList, searchTerm, isSuggestionSelected, taxonomyPathString, filters, searchPage = 0) {
    searchPage++;
    if (!filters) {
        filters = {
            books: [],
            authors: [],
            subjects: [],
            itemTypes: [],
            favouriteOnly: false
        };
    }
    const { books, authors, subjects, itemTypes, favouriteOnly } = filters;
    return async dispatch => {
        dispatch({
            type: searchPage === 1 ? types.SEARCH_EXERCISES : types.SEARCH_MORE_EXERCISES,
            filters: {
                books,
                authors,
                subjects,
                itemTypes,
                favouriteOnly
            },
            searchTerm,
            page: searchPage,
            idList,
            isSuggestionSelected,
            taxonomyPathString
        });
        try {
            const {
                data: { data, totalCount }
            } = await axios.post(`${API_URL}/cv/getItemsByContentPaths`, {
                contentPath: idList,
                page: searchPage,
                books: Array.isArray(books) && books.length > 0 ? parserUtils.getElementsFromArrayByProp('ids', books) : undefined,
                authors: Array.isArray(authors) && authors.length > 0 ? parserUtils.getElementsFromArrayByProp('id', authors) : undefined,
                subjects: Array.isArray(subjects) && subjects.length > 0 ? parserUtils.getElementsFromArrayByProp('ids', subjects) : undefined,
                itemTypes: Array.isArray(itemTypes) && itemTypes.length > 0 ? parserUtils.getElementsFromArrayByProp('id', itemTypes) : undefined,
                origin: applications.CREA_VERIFICHE,
                favourites: favouriteOnly
            });
            dispatch({
                type: searchPage === 1 ? types.SEARCH_EXERCISES_SUCCESS : types.SEARCH_MORE_EXERCISES_SUCCESS,
                result: data.map(e => ({ ...fixExerciseStructure(e), contextId: getContextId(idList) })),
                totalCount,
                searchPage,
                favourites: favouriteOnly
            });
        } catch (e) {
            handleUnauthorizedError(e, dispatch);
            dispatch({
                type: searchPage === 1 ? types.SEARCH_EXERCISES_FAILURE : types.SEARCH_MORE_EXERCISES_FAILURE,
                error: e
            });
        }
    };
}

export function updateExercise(exerciseId, exerciseToSave, exerciseInfo, callbackAfterSuccess) {
    const url = `${API_URL}/cat/item/${exerciseId}`;
    return async dispatch => {
        dispatch({ type: types.UPDATE_EXERCISE });
        const bodyPost = {
            ...exerciseToSave,
            applicationId: applications.CREA_VERIFICHE
        };
        try {
            const { data } = await axios.put(url, bodyPost);
            const exercise = {
                UGC: true,
                id: data.id,
                ...(data.sharedtextNodeId && { sharedtextNodeId: data.sharedtextNodeId }),
                ...(data.sharedTextXml && { sharedTextXml: data.sharedTextXml }),
                ...(data.audioNodeId && { audioNodeId: data.audioNodeId }),
                ...(data.audioXml && { audioXml: data.audioXml }),
                subject: exerciseInfo.subject,
                taxonomy: convertContentPathsToTaxonomy(data.contentPaths),
                title: data.publicTitle,
                type: {
                    id: data.type,
                    label: translateItemTypesName(data.typeLabel)
                },
                difficulty: data.difficulty,
                xml: getAbsolutePathforImageAndAudio(data.xml)
            };
            dispatch({
                type: types.UPDATE_EXERCISE_SUCCESS,
                exercise
            });
            if (callbackAfterSuccess) {
                callbackAfterSuccess(exercise);
            }
        } catch (e) {
            handleUnauthorizedError(e, dispatch);
            dispatch({
                type: types.UPDATE_EXERCISE_FAILURE,
                error: e
            });
        }
    };
}

export function deleteExerciseFromArchive(exerciseId, callback) {
    const url = `${API_URL}/cat/item/${exerciseId}`;
    return async dispatch => {
        dispatch({ type: types.DELETE_EXERCISE });
        try {
            await axios.delete(url);
            if (callback) {
                callback(null);
            }
            dispatch({
                type: types.DELETE_EXERCISE_SUCCESS,
                id: exerciseId
            });
        } catch (e) {
            handleUnauthorizedError(e, dispatch);
            dispatch({
                type: types.DELETE_EXERCISE_FAILURE
            });
            if (callback) {
                callback(e);
            }
        }
    };
}

export function uploadImage(file) {
    return async dispatch => {
        try {
            dispatch({ type: UPLOAD_IMAGE_START });
            const image = new FormData();
            image.append('image', file);
            const { data } = await axios.post(`${API_URL}/cat/item/upload-image`, image);
            dispatch({
                type: UPLOAD_IMAGE_SUCCESS,
                payload: data
            });
            return {
                data: {
                    link: `${S3_IMAGES_URL}${data.message}`
                }
            };
        } catch (e) {
            handleUnauthorizedError(e, dispatch);
            dispatch({
                type: UPLOAD_IMAGE_FAILURE,
                error: true,
                payload: e
            });
        }
    };
}

export function onEditorialExercisesFiltersChange(filters, searchIdList, searchTerm) {
    return dispatch => {
        dispatch({
            type: types.EXERCISES_EDITORIAL_FILTERS_CHANGE,
            filters,
            searchIdList,
            searchTerm
        });
    };
}
